import { ChangeEvent, useCallback, useState } from "react";

import ToggleSliderMarkup from "./markup";
import { BaseProps } from "./types";

export function ToggleSlider(props: BaseProps) {
	const { trueLabel = "Yes", falseLabel = "No", labelPosition = "right", rounded = true } = props;

	const onChange = useCallback(
		(event: ChangeEvent<HTMLInputElement>) => {
			if (props.disabled) return;
			if (props.changeHandler) {
				props.changeHandler(event.target.checked, props.id);
			}
		},
		[props.changeHandler, props.id, props.disabled],
	);

	return (
		<ToggleSliderMarkup
			{...props}
			trueLabel={trueLabel}
			falseLabel={falseLabel}
			labelPosition={labelPosition}
			rounded={rounded}
			onChange={onChange}
		/>
	);
}

export * from "./types";
